import { Trans } from '@lingui/react'

const AdditionalInformation = () => (
  <div className="u-color--grey">
    <span className="u-font-weight--bold">
      <Trans id="product.listing.promotion.label" />:{' '}
      <Trans id="product.listing.promotion.additionalInformation.freebie" />
    </span>
  </div>
)

export default AdditionalInformation
